import "core-js/modules/es.array.includes.js";
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import './mg-flex.less';
export default {
  __name: 'mg-flex',
  props: {
    align: {
      type: String,
      default: '',
      validator: val => ['', 'top-left', 'top-center', 'top-right', 'center', 'center-left', 'center-right', 'bottom-left', 'bottom-right', 'bottom-center'].includes(val)
    },
    vertical: {
      type: Boolean,
      default: false
    },
    // true: 垂直布局,false:水平布局
    enableHover: {
      type: Boolean,
      default: false
    },
    hoverBkColor: {
      type: String,
      default: '#7dc3ec'
    },
    hoverColor: {
      type: String,
      default: '#002b48'
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        style: _normalizeStyle({
          '--mg-ui-flex-hover-bk-color': __props.hoverBkColor,
          '--mg-ui-flex-hover-color': __props.hoverColor
        }),
        class: _normalizeClass(['mg-ui-flex', {
          'enable--hover': __props.enableHover
        }, {
          'is--horizontal': !__props.vertical,
          'is--vertical': __props.vertical,
          'align--top-left': __props.align === 'top-left',
          'align--top-center': __props.align === 'top-center' || __props.align === '',
          'align--top-right': __props.align === 'top-right',
          'align--center': __props.align === 'center',
          'align--bottom-left': __props.align === 'bottom-left',
          'align--bottom-center': __props.align === 'bottom-center',
          'align--bottom-right': __props.align === 'bottom-right',
          'align--center-left': __props.align === 'center-left',
          'align--center-right': __props.align === 'center-right'
        }])
      }, [_renderSlot(_ctx.$slots, "default")], 6);
    };
  }
};